import { Component } from 'react';

import { fieldProps } from '../../types';

class NullField extends Component {
  componentDidMount() {
    if (this.props.formData === undefined) {
      this.props.onChange(null);
    }
  }

  render() {
    return null;
  }
}

NullField.propTypes = fieldProps;

export default NullField;
